/**
 * Contains the logic for the automatic display of active payment bonuses in the slideshows for the *AuthUser*.
 * Deals with the following slideshows
 * - Slideshow on the Start Page
 * - Slideshow in the Sidebar
 *
 * ### TODO
 * 1. CSS identifiers must not begin with a number! (e.g. "100percent")
 *     a.t.m. acng style selectors might use those css class identifiers.
 *
 * @module PaymentBonus
 * @author Jacob Viertel <jv@onscreen.net>, Nils Engel <ne@onscreen.net>
 * @see [AuthUser](../../userPool/context/auth-user.js)
 */

// bounty, rubicon
import {get, remove as unset} from '@acng/frontend-bounty/dom/attribute.js';
import {remove} from '@acng/frontend-bounty/dom/move.js';
import {find} from '@acng/frontend-bounty/dom/template.js';
// enterprise & relativity
import {ctxBonusList} from 'acng/payment/context/bonus-list.js';
import {GlobalWatch} from '@acng/frontend-relativity';
import {getSlideshowSidebar, getSlideshowUserHome} from 'acng/layout/service/sequence.js';
import {SLIDESHOW_INDEX} from 'acng/layout/element/slideshow.js';
import {NOVA_TEASER} from 'acng/layout/style/teaser.js';
import {feature} from '../service/template.js';

const MODULE = 'payment/context/slideshow';
const VERBOSE = false;
DEBUG: if (VERBOSE) console.warn(`import verbose ${MODULE}`);

GlobalWatch(ctxBonusList)(async (bonusList) => {
  DEBUG: if (VERBOSE) console.warn(`${MODULE} update bonus teaser in the slideshows`, bonusList);
  const slideshowSidebar = getSlideshowSidebar().template;
  const slideshowUserHome = getSlideshowUserHome().template;

  for (const element of [...slideshowUserHome.content.children, ...slideshowSidebar.content.children]) {
    const bonusName = get(element, 'data-bonus');

    if (bonusName && !bonusList.find((bonus) => bonus.name === bonusName)) {
      remove(element);
    }
  }

  for (const bonus of bonusList.slice().reverse()) {
    const homeTeaser = await feature.lookup('bonus-teaser', bonus.name, 'overlay');
    const sidebarTeaser = await feature.lookup('bonus-teaser', bonus.name, 'sidebar');

    if (!find(slideshowUserHome, `.${NOVA_TEASER}.bonus-${bonus.name}`)) {
      unset(slideshowUserHome, SLIDESHOW_INDEX);
      unset(slideshowSidebar, SLIDESHOW_INDEX);
      slideshowUserHome.content.prepend(homeTeaser);
      slideshowSidebar.content.prepend(sidebarTeaser);
    }
  }
});
